module.exports = __webpack_public_path__ + "img/header-bg@3x.75f67591.png";